// @flow

import React, { Component } from 'react';

import SiteNavbar from './SiteNavbar';

import ErrorWrapper from './errors/ErrorWrapper';
import type { ModeCollection } from '../modes';

const GenericPage = ({
    currentModeName,
    modes,
    component,
    isDarkMode,
    toggleTheme,
}: {
    currentModeName: string,
    modes: ModeCollection,
    component: Component,
    isDarkMode: boolean,
    toggleTheme: () => void,
}): Component => (
    <div className="app-shell">
        <SiteNavbar
            currentModeName={currentModeName}
            modes={modes}
            isDarkMode={isDarkMode}
            toggleTheme={toggleTheme}
        />
        <div className={`page-shell${currentModeName === 'launch-status' ? ' page-shell--launch-status' : ''}`}>
            <ErrorWrapper>{component}</ErrorWrapper>
        </div>
    </div>
);

export default GenericPage;
